/*
Author: Chathuraka Mallawa Arachchi
Date: 25/09/2024
Copyright © 2024 Infix!. All rights reserved.
*/

import {QuestionNode} from "@/components/survey";
import {INode} from "@/components/survey/SurveyModel/types/nodeTypes";
import React from "react";


const HealthImprovmentPatient = (props: any ) => {
    const {name, node, formData, onChange } = props;

    return (
        <React.Fragment>
            {node.nodes.map((node:INode, index:number)=>((<QuestionNode name={name} key={index} node={node} onChange={onChange} formData={formData} />)))}
        </React.Fragment>
    )
}

export default HealthImprovmentPatient;